import { render, staticRenderFns } from "./JsonTableField.vue?vue&type=template&id=2d0e01c4&scoped=true&"
import script from "./JsonTableField.vue?vue&type=script&lang=js&"
export * from "./JsonTableField.vue?vue&type=script&lang=js&"
import style0 from "./JsonTableField.vue?vue&type=style&index=0&id=2d0e01c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e01c4",
  null
  
)

export default component.exports